import { Box, Button, Flex, HStack, Text } from "@chakra-ui/react";
import { FileText } from "lucide-react";
import { surfaceShadow, type DocumentKey } from "../constants";

export function DocumentCard({
  docKey,
  docName,
  isUploaded,
  error,
  onFileClick,
  onFileChange,
  fileInputRefs,
}: {
  docKey: DocumentKey;
  docName: string;
  isUploaded: boolean;
  error?: string;
  onFileClick: (key: DocumentKey) => void;
  onFileChange: (key: DocumentKey, e: React.ChangeEvent<HTMLInputElement>) => void;
  fileInputRefs: React.MutableRefObject<Partial<Record<string, HTMLInputElement | null>>>;
}) {
  return (
    <Box
      data-onboarding-error={error ? "true" : undefined}
      bg={error ? "red.50" : "white"}
      borderRadius="xl"
      borderWidth={error ? "1px" : "0"}
      borderColor={error ? "red.200" : "transparent"}
      boxShadow={error ? "none" : surfaceShadow}
      p={5}
      transition="all 0.2s"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <HStack gap={4}>
          <Box p={3} borderRadius="xl" bg="gray.100" color="gray.600">
            <FileText size={24} />
          </Box>
          <Box>
            <Text fontWeight="semibold" color="gray.900">
              {docName}
            </Text>
            <Text
              fontSize="sm"
              fontWeight="medium"
              color={isUploaded ? "green.600" : "gray.500"}
              mt={0.5}
            >
              {isUploaded ? "Archivo cargado exitosamente" : "Pendiente"}
            </Text>
          </Box>
        </HStack>
        <Button
          colorPalette="gray"
          variant="outline"
          onClick={() => onFileClick(docKey)}
        >
          {isUploaded ? "Reemplazar archivo" : "Seleccionar archivo"}
        </Button>
      </Flex>
      {error && <Text mt={3} fontSize="xs" color="red.500">{error}</Text>}
      <input
        ref={(el) => { fileInputRefs.current[docKey] = el; }}
        type="file"
        hidden
        onChange={(e) => onFileChange(docKey, e)}
      />
    </Box>
  );
}
